<template>
  <li
    class="list-group-item d-flex align-items-center pd-0-f"
    :class="{
      'bg-gray-100': source.examData.isDownloadData != 1,
      'bg-gray-300': source.executeFlag == 5
    }"
  >
    <div
      class="d-flex align-items-center pd-x-10 bd-r"
      style="width: calc(50%)"
    >
      <img
        :src="`${source.user.avator}`"
        class="wd-40 ht-40 rounded mg-r-10"
        alt=""
      />
      <div>
        <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
          {{ source.user.fullName }} | {{ source.user.loginName }}
        </h6>
        <div class="d-block tx-11 text-muted d-flex align-items-center">
          {{ source.user.departName }}
          <i class="fas fa-chevron-right mg-x-5"></i>
          {{ source.user.position }}
        </div>
        <div class="d-block tx-11 text-muted d-flex align-items-center">
          {{ source.user.register }} | {{ source.user.mobile }} |
          {{ source.user.email }}
        </div>
      </div>
      <div class="mg-l-auto" v-html="getStatus(source)"></div>
    </div>
    <div
      class="text-center tx-14 wd-100 pd-x-10 bd-r"
      role="button"
      @click="$parent.$parent.$emit('on-filled', source.userId)"
    >
      {{ source.examData.avsanOnoo.toFixed(2) }} /
      {{ source.examData.allPoint }}
    </div>
    <div class="pd-x-10 wd-100 bd-r" title="Шалгалтын дүн">
      {{ source.examData.dun.toFixed(2) }}%
    </div>
    <template
      v-if="
        config.course != undefined &&
          config.course.solveResult != undefined &&
          config.course.solveResult == 1
      "
    >
      <div
        class="text-center tx-14 wd-100 pd-x-10 bd-r"
        role="button"
        @click="$parent.$parent.$emit('on-filled', source.userId)"
      >
        {{ source.result.irtsDun }}
      </div>
      <div
        class="text-center tx-14 wd-100 pd-x-10 bd-r"
        role="button"
        @click="$parent.$parent.$emit('on-filled', source.userId)"
      >
        {{ source.result.yavtsDun }}
      </div>
      <div
        class="text-center tx-16 wd-100 pd-x-10 bd-r"
        role="button"
        @click="$parent.$parent.$emit('on-filled', source.userId)"
      >
        {{ source.result.examDun.toFixed(2) }}%
      </div>
    </template>
    <div class="pd-x-10 wd-100 bd-r" title="Нэмэлт оноо">
      <a
        @click="$parent.$parent.$emit('on-point', source)"
        class="link-01 tx-18"
        role="button"
        >{{ source.result.addedDun }}</a
      >
    </div>
    <div class="pd-x-10 wd-150 bd-r" title="Сертификат дүн">
      {{ source.result.certDun.toFixed(2) }}%
    </div>
    <div class="mg-l-auto wd-100 pd-x-10 pd-y-5">
      <b-dropdown id="dropdown-1" right size="sm" text="Цэс">
        <b-dropdown-item
          @click="$parent.$parent.$emit('on-notification', source.userId)"
          >Сануулга илгээх</b-dropdown-item
        >
        <b-dropdown-item
          @click="$parent.$parent.$emit('on-remove', source.userId)"
          >Өгөгдөл татсан бичилт устгах</b-dropdown-item
        >
        <b-dropdown-item>Сургалтад хамрагдсан байдал</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item
          @click="$parent.$parent.$emit('on-filled', source.userId)"
          >Шалгалт бөглөсөн байдал</b-dropdown-item
        >
        <!-- <b-dropdown-item @click="$parent.$parent.$emit('on-finish', source.userId)">Дүн засаж дуусгасан</b-dropdown-item> -->
        <b-dropdown-item
          @click="$parent.$parent.$emit('on-certificate', source.userId)"
          active
          >Сертификат</b-dropdown-item
        >
        <b-dropdown-item
          @click="$parent.$parent.$emit('on-certificate-re', source.userId)"
          >Сертификат шинэчлэх</b-dropdown-item
        >
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item
          v-if="source.executeFlag == 0"
          @click="
            $parent.$parent.$emit('on-change-shareflag', {
              userId: source.userId,
              flag: 5
            })
          "
          >Багш болгох</b-dropdown-item
        >
        <b-dropdown-item
          v-if="source.executeFlag == 5"
          @click="
            $parent.$parent.$emit('on-change-shareflag', {
              userId: source.userId,
              flag: 0
            })
          "
          >Сурагч болгох</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <!-- <button @click="$parent.$parent.$emit('on-action', source.id)" class="btn btn-xs btn-outline-success mg-l-auto">
      <feather type="user-plus"></feather>
      Нэмэх
    </button> -->
  </li>
</template>

<script>
export default {
  name: "item-component",
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      }
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    getStatus(s) {
      //console.log('s=> ', s);
      let rv = "";
      let cls = "";
      //console.log(s.examData);
      if (s.examData.isDownloadData == 1) {
        //console.log(s.examData.isFinished);
        if (s.examData.isFinished == null) rv = "дүн илгээгээгүй";
        else if (s.examData.isFinished == -333 || s.examData.isFinished == -1)
          rv = "дүн боловсруулаагүй";
        else if (s.examData.isFinished == 770) rv = "дүн хянагдаагүй";
        else if (s.examData.isFinished == 1
        //|| s.examData.isFinished == 9
        ) {
          rv = "дүн хянагдсан";
          cls = "bg-success text-white";
        } else if (s.examData.isFinished == 0) rv = "дүн илгээгээгүй";
      } else {
        rv = "өгөдөл татаагүй";
      }
      return `<div class="marker ${cls}">${rv}</div>`;
    }
  }
};
</script>
